import { NotificationsService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const notificationAnalyticsQueryKey = (congressId: string) => {
  return ["notification-analytics", congressId] as const;
};

function useNotificationAnalytics(congressId: string) {
  return useQuery({
    queryKey: notificationAnalyticsQueryKey(congressId),
    queryFn: () => NotificationsService.getAvailableDevices({ congressId }),
  });
}

export { notificationAnalyticsQueryKey, useNotificationAnalytics };
